import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { AppDownloadServiceModule } from '@ftr/api-core'
import { AnchorComponent, FocusableNoopAnchorDirective } from '@ftr/foundation'
import { DeepLinkService } from '../../services/deep-link/deep-link.service'
import { DeepLinkComponent } from './deep-link/deep-link.component'
import { OpenInAppComponent } from './open-in-app/open-in-app.component'

@NgModule({
  imports: [AnchorComponent, CommonModule, FocusableNoopAnchorDirective],
  declarations: [OpenInAppComponent, DeepLinkComponent],
  exports: [OpenInAppComponent, DeepLinkComponent],
  providers: [DeepLinkService, AppDownloadServiceModule],
})
export class DesktopModule {}
